/* IM Cart – drawer + réduction + affichage 3POUR2 + variantes propres */
(() => {
  'use strict';

  const $ = (q, c = document) => c.querySelector(q);
  const root = $('#im-cart');
  if (!root) return;

  /* ---------- Raccourcis éléments ---------- */
  const els = {
    items: $('[data-imc-items]', root),
    empty: $('[data-imc-empty]', root),

    // Livraison offerte
    shipWrap: $('[data-imc-shipprog]', root),
    shipMsg: $('[data-imc-ship-msg]', root),
    shipCount: $('[data-imc-ship-count]', root),
    shipBar: $('[data-imc-ship-bar]', root),

    // Discount UI
    discTog: $('[data-imc-disc-tog]', root),
    discPanel: $('#imc-disc-panel', root),
    discInput: $('[data-imc-disc-input]', root),
    discApply: $('[data-imc-disc-apply]', root),
    discHint: $('[data-imc-disc-hint]', root),
    discLine: $('[data-imc-disc-line]', root),
    discCode: $('[data-imc-disc-code]', root),
    discClear: $('[data-imc-disc-clear]', root),

    // Récap
    shippingRow: $('[data-imc-shipping-row]', root),
    shippingValue: $('[data-imc-shipping]', root),
    beforeRow: $('[data-imc-before-row]', root),
    before: $('[data-imc-before]', root),
    discountRow: $('[data-imc-discount-row]', root),
    discAmount: $('[data-imc-disc-amount]', root),

    // Totaux + checkout
    total: $('[data-imc-total]', root),
    totalLoader: $('[data-imc-total-loader]', root),
    count: $('[data-imc-count]', root),
    checkout: $('[data-imc-checkout]', root),
    // Audit 27/10 (ACH22) : tiroir vide → « Voir les maillots » à la place de « Payer » + petit message
    browse: $('[data-imc-browse]', root),
    emptyNote: $('[data-imc-empty-note]', root),

    // Note panier
    noteInput: $('[data-imc-note-input]', root),
    noteStatus: $('[data-imc-note-status]', root),
  };

  const HEADER_COUNT_SELECTORS = [
    '#im-cart-count',
    '.js-cart-count',
    '.site-header__cart-indicator',
    '.header-cart-count',
    '[data-cart-count]'
  ].join(',');

  const toSafeCount = (raw) => {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.floor(n);
  };

  function syncHeaderCounts(rawCount) {
    const count = toSafeCount(rawCount);
    // Relecture 03/11 : la « Décision VAR » se cale sur le compteur des PALIERS (rendu du tiroir),
    // pas sur le nombre brut d'articles (Pack Duo / vestes ne donnent pas de maillot offert)
    const nodes = document.querySelectorAll(HEADER_COUNT_SELECTORS);
    if (!nodes.length) return;
    nodes.forEach((el) => {
      el.textContent = String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  /* ---------- « Décision VAR » : célébration sobre au franchissement d'un palier cadeau ---------- */
  let imcLastCount = null; // null = pas encore initialisé (on ne célèbre jamais l'état initial)
  function checkVarMoment(count) {
    if (imcLastCount === null) { imcLastCount = count; return; }
    /* Priorité au palier le plus haut : un saut direct 2→6 (saisie clavier)
       célèbre le 6ᵉ offert (le plus gros avantage), pas seulement le 3ᵉ. */
    if (imcLastCount < 6 && count >= 6) varMoment(6);
    else if (imcLastCount < 3 && count >= 3) varMoment(3);
    imcLastCount = count;
  }
  function varMoment(kind) {
    try {
      if (sessionStorage.getItem('imc_var_' + kind)) return; // une seule fois par session et par palier
      sessionStorage.setItem('imc_var_' + kind, '1');
    } catch (e) { /* stockage bloqué : on célèbre quand même, au pire 2× */ }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const d = document.createElement('div');
    d.className = 'imc-var';
    d.setAttribute('role', 'status'); // annoncé par les lecteurs d'écran à l'insertion
    d.innerHTML =
      '<div class="imc-var__card"><span class="imc-var__k">Décision VAR</span>' +
      '<span class="imc-var__v">' + (kind === 3 ? '3ᵉ maillot offert' : '6ᵉ maillot offert') +
      ' — accordé <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 5 5L19 7"/></svg></span></div>';
    document.body.appendChild(d);
    requestAnimationFrame(() => d.classList.add('is-on'));
    setTimeout(() => { d.classList.remove('is-on'); setTimeout(() => d.remove(), 400); }, 1500);
    try { navigator.vibrate && navigator.vibrate(35); } catch (e) { /* no-op */ }
  }

  let headerRefreshTimer = null;
  let headerRefreshInFlight = false;
  function queueHeaderCountRefresh(delay = 80) {
    if (headerRefreshTimer) clearTimeout(headerRefreshTimer);
    headerRefreshTimer = setTimeout(async () => {
      if (headerRefreshInFlight) return;
      headerRefreshInFlight = true;
      try {
        const c = await getCart();
        syncHeaderCounts(c?.item_count || 0);
      } catch (e) {
        /* no-op */
      } finally {
        headerRefreshInFlight = false;
      }
    }, delay);
  }

  function installHeaderCountAutoRefresh() {
    if (!window.__imcHeaderCountPatchFetch && typeof window.fetch === 'function') {
      const nativeFetch = window.fetch.bind(window);
      window.fetch = function patchedFetch(resource, init) {
        const url = (typeof resource === 'string' ? resource : resource?.url) || '';
        const watch = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url);
        return nativeFetch(resource, init).then(
          (res) => {
            // Audit 27/10 (ACH22) : une écriture panier a eu lieu → un panier vide ensuite n'est PAS « expiré »
            if (watch) _cartWriteSeen = true;
            // Skip si c'est NOTRE opération interne (render() met déjà le compteur à jour)
            if (watch && !_suppressHeaderRefresh) queueHeaderCountRefresh(60);
            return res;
          },
          (err) => {
            if (watch) _cartWriteSeen = true;
            if (watch && !_suppressHeaderRefresh) queueHeaderCountRefresh(120);
            throw err;
          }
        );
      };
      window.__imcHeaderCountPatchFetch = true;
    }

    if (!window.__imcHeaderCountPatchXhr && window.XMLHttpRequest) {
      const xhrOpen = window.XMLHttpRequest.prototype.open;
      const xhrSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
        this.__imcWatchCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url || ''));
        return xhrOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function patchedSend() {
        if (this.__imcWatchCart) {
          // Audit 27/10 (ACH22) : même marqueur « écriture panier vue » que pour fetch
          this.addEventListener('loadend', () => { _cartWriteSeen = true; queueHeaderCountRefresh(70); }, { once: true });
        }
        return xhrSend.apply(this, arguments);
      };
      window.__imcHeaderCountPatchXhr = true;
    }
  }

  /* === AJOUT : helper shimmer sur le total === */
  const setTotalLoading = (on) => {
    if (!els.total) return;
    els.total.classList.toggle('imc-total--loading', !!on);
    els.total.setAttribute('aria-busy', on ? 'true' : 'false');
    if (els.totalLoader) els.totalLoader.hidden = !on;
  };

  /* ---------- Helpers ---------- */
  const cur = (window.Shopify?.currency?.active) || 'EUR';
  /* Audit 27/10 (ACH23) : format FRANÇAIS forcé (« 30,90 € »), quelle que soit la langue du
     téléphone — avant, toLocaleString(undefined) donnait « €30.90 » en anglais, « EUR 65.80 »
     en suisse allemand. La devise reste celle de la boutique (cur), seul l'affichage change. */
  const moneyFmt = (() => {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }); }
    catch (_) { return null; }
  })();
  const money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    if (moneyFmt) return moneyFmt.format(v);
    return v.toFixed(2).replace('.', ',') + ' €';
  };

  const labelMap = new Map([
    // normalisations -> étiquettes voulues
    ['s', 'Taille'],
    ['taille', 'Taille'],
    ['nom', 'Nom'],
    ['numero', 'Numéro'],
    ['numéro', 'Numéro'],
    ['name_below', 'Nom en dessous'],
    ['nom_en_dessous', 'Nom en dessous'],
    ['nom_sous_le_numero', 'Nom en dessous'],
    ['nom sous le numéro', 'Nom en dessous'],
    ['sous le numéro', 'Nom en dessous'],
    ['sous le numero', 'Nom en dessous'],
  ]);

  const norm = (k) => String(k || '').trim().toLowerCase();

  // Estimations de remise DÉSACTIVÉES (aucun code réel configuré côté Shopify).
  // Le code saisi est tout de même transmis au checkout, où la vraie remise s'applique.
  const parsePct = (code) => 0;
  const safeLocalRemove = (key) => {
    try { window.localStorage.removeItem(key); } catch (_) {}
  };
  // Audit 27/10 (ACH22) : lecture/écriture localStorage protégées (stockage bloqué = pas de message, jamais d'erreur)
  const safeLocalGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  };
  const safeLocalSet = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  };
  const safeSessionGet = (key) => {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  };
  const safeSessionSet = (key, value) => {
    try { window.sessionStorage.setItem(key, value); } catch (_) {}
  };
  const safeSessionRemove = (key) => {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  };

  let cart = { items: [], items_subtotal_price: 0, item_count: 0 };
  // Quand true, le patch fetch global ne déclenche PAS de refresh header redondant
  // (utilisé pendant nos propres opérations qui rafraîchissent déjà le compteur)
  let _suppressHeaderRefresh = false;
  /* Audit 27/10 (ACH22) : vrai dès qu'une écriture panier (ajout, quantité, retrait…) a eu lieu
     depuis le dernier rendu. Un panier qui passe à 0 SANS écriture = il s'est vidé tout seul
     (expiré, ou commande déjà payée) → petit message dans le tiroir vide. */
  let _cartWriteSeen = false;
  let _expiredNotice = safeSessionGet('imc_cart_expired') === '1';
  /* Audit 27/10 (ACH6) : compteur des écritures appliquées par NOS opérations. Une lecture
     /cart.js partie AVANT une écriture et revenue APRÈS est périmée : on l'ignore. */
  let _cartWriteSeq = 0;
  let noteSaveTimer = null;
  let lastSavedNote = '';
  const FREE_SHIP_THRESHOLD = 2;
  let lastShippingStep = -1;
  let shippingAnimTimer = null;
  let shipBurstTimer = null;

  /* IM FIX:
     - Aucun code promo ne doit être mémorisé entre sessions/page reload.
     - Le code promo manuel reste uniquement en mémoire de la page courante.
  */
  let discountCode = '';

  // Montants calculés côté affichage
  let estimatedPercentDiscount = 0;   // pour codes % (ex. EMMA20)

  /* ---------- API Shopify ---------- */
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  /* ============================================================
     REGROUPEMENT des lignes scindées par la remise automatique.
     La Shopify Function « Paliers » scinde une même variante en plusieurs
     lignes aux CLÉS DIFFÉRENTES (plein tarif / −35% / offert). Pour le client
     c'est UNE ligne. Sans regroupement, changer la quantité « par clé » ne
     touche qu'une des lignes et le total dérive (bug prouvé : 6 voulu → 9).
     ============================================================ */
  let _lineGroupByKey = new Map(); // clé affichée (1re du groupe) -> [toutes les clés du groupe]

  /* Audit 27/10 (ACH6) : identifiant STABLE d'un groupe (variante + perso). Les clés de ligne,
     elles, changent à chaque re-découpage de la remise : on ne s'y fie qu'au moment d'envoyer,
     relues dans le dernier panier reçu. */
  const gidOf = (it) => `${it.variant_id}|${JSON.stringify(it.properties || {})}`;

  function groupCartItems(items) {
    const byId = new Map(); // variant|props -> item fusionné
    const out = [];
    _lineGroupByKey = new Map();
    (items || []).forEach((it) => {
      const gid = gidOf(it);
      if (!byId.has(gid)) {
        const merged = Object.assign({}, it);
        merged.gid = gid;
        // La Function isole l'unité offerte sur sa propre ligne scindée (final 0) :
        // on compte COMBIEN d'unités du groupe sont réellement gratuites, pour ne
        // jamais étiqueter « Offert » (implicite : toute la ligne) une ligne dont
        // une partie seulement est offerte — sinon le prix affiché à côté (non nul)
        // contredit le badge.
        merged.zeroUnitQty = (it.final_line_price === 0 && (it.original_line_price || 0) > 0) ? (it.quantity || 0) : 0;
        byId.set(gid, merged);
        out.push(merged);
        _lineGroupByKey.set(merged.key, [it.key]);
      } else {
        const m = byId.get(gid);
        m.quantity = (m.quantity || 0) + (it.quantity || 0);
        m.line_price = (m.line_price || 0) + (it.line_price || 0);
        m.final_line_price = (m.final_line_price || 0) + (it.final_line_price || 0);
        m.original_line_price = (m.original_line_price || 0) + (it.original_line_price || 0);
        m.zeroUnitQty = (m.zeroUnitQty || 0) + ((it.final_line_price === 0 && (it.original_line_price || 0) > 0) ? (it.quantity || 0) : 0);
        _lineGroupByKey.get(m.key).push(it.key);
      }
    });
    return out;
  }

  /* ============================================================
     Audit 27/10 (ACH6) : UNE SEULE FILE D'ATTENTE pour toutes les écritures du tiroir
     (quantités, retraits, ajout rapide, note) et pour ses relectures /cart.js.
     Bug prouvé : 2 « + » rapides sur 2 lignes différentes = 2 requêtes en parallèle ; la 1re
     re-découpe les lignes (remise) → la 2e part avec des clés périmées → une quantité BAISSE
     (7 maillots attendus, 5 au panier). Désormais une opération ne démarre qu'une fois la
     précédente finie, et lit ses clés dans le panier que celle-ci vient de renvoyer.
     ============================================================ */
  let _cartQueue = Promise.resolve();
  let _cartBusy = 0;                // écritures en cours (aria-busy) — les − / + restent actifs :
                                    // un tap pendant l'envoi est mémorisé et part juste après
  const CART_OP_MAX_MS = 15000;     // filet : une requête muette ne bloque jamais la file plus de 15 s

  // Les − / + ne sont PAS grisés pendant l'envoi : un bouton désactivé perdrait les taps faits
  // pendant la requête (240 ms + latence 4G). La file les mémorise (_qtyOps) et les envoie juste après.
  function setCartBusy(on) {
    if (!els.items) return;
    els.items.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  // enqueueCartOp(tâche, ecriture) : lance la tâche quand la précédente est terminée.
  // ecriture = true → − / + grisés pendant la requête.
  function enqueueCartOp(task, isWrite) {
    let unblock;
    const gate = new Promise((r) => { unblock = r; });
    const run = _cartQueue.then(() => {
      let ended = false;
      let guard = null;
      const end = () => {
        if (ended) return;
        ended = true;
        clearTimeout(guard);
        if (isWrite && --_cartBusy === 0) setCartBusy(false);
        unblock();
      };
      if (isWrite && ++_cartBusy === 1) setCartBusy(true);
      guard = setTimeout(end, CART_OP_MAX_MS);
      const p = Promise.resolve().then(task);
      p.then(end, end);
      return p;
    });
    _cartQueue = gate;
    return run;
  }

  // Une de NOS écritures vient d'aboutir (ou d'échouer) côté serveur
  function markCartWrite() {
    _cartWriteSeq++;
    _cartWriteSeen = true;
  }

  // Relecture du panier (/cart.js) PAR LA FILE : une écriture demandée juste après attend ce
  // panier frais. Plusieurs demandes encore en attente = une seule relecture.
  let _refreshPending = null;
  function refreshCart() {
    if (_refreshPending) return _refreshPending;
    const p = enqueueCartOp(() => { _refreshPending = null; return render(); }, false);
    _refreshPending = p;
    return p;
  }

  /* Quantités : on mémorise l'INTENTION par groupe (gid), plus une cible figée par clé :
     - « + » / « − » = un écart (+1 / −1) appliqué à la quantité TOTALE du groupe telle que le
       serveur la donne au moment d'envoyer → un « + » ne peut plus faire baisser une quantité,
       même si l'affichage avait du retard (retour arrière, 2 onglets) ;
     - saisie clavier / « Retirer » = une quantité exacte.
     Clics rapides accumulés (debounce) → 1 seule requête /cart/update.js pour TOUS les groupes
     touchés ; optimistic UI immédiat, anti-flash, resync en cas d'erreur. */
  const _qtyOps = new Map();      // gid -> { abs: quantité exacte | null, delta: écart cumulé }
  const _qtyInFlight = new Map(); // gid -> quantité totale envoyée (requête en cours)
  let _qtyTimer = null;
  let _qtyFlushQueued = false;
  const QTY_DEBOUNCE_MS = 240;

  // Quantité à afficher pour un groupe : intention en attente > envoi en cours > serveur
  function pendingQty(gid, serverQty) {
    const base = _qtyInFlight.has(gid) ? _qtyInFlight.get(gid) : serverQty;
    const op = _qtyOps.get(gid);
    if (!op) return base;
    return op.abs !== null ? op.abs : Math.max(0, base + op.delta);
  }

  // how = { delta: ±1 } ou { abs: n } ; itemEl = la ligne affichée ; serverQty = total du groupe au rendu
  function changeQty(gid, how, itemEl, serverQty) {
    if (gid == null) return;
    const op = _qtyOps.get(gid) || { abs: null, delta: 0 };
    if (typeof how.abs === 'number') { op.abs = Math.max(0, how.abs | 0); op.delta = 0; }
    else if (op.abs !== null) op.abs = Math.max(0, op.abs + (how.delta | 0));
    else op.delta += (how.delta | 0);
    _qtyOps.set(gid, op);
    const qty = pendingQty(gid, serverQty);

    // Optimistic UI immédiat (ressenti instantané)
    if (itemEl) {
      if (qty <= 0) {
        itemEl.classList.add('removing');
        itemEl.querySelectorAll('button, input').forEach(n => { n.disabled = true; });
      } else {
        const input = itemEl.querySelector('.imc-qty__input');
        if (input) input.value = qty;
      }
    }
    setTotalLoading(true);

    // Debounce GLOBAL : on attend que les clics rapides (toutes lignes confondues) se calment
    if (_qtyTimer) clearTimeout(_qtyTimer);
    _qtyTimer = setTimeout(() => {
      _qtyTimer = null;
      if (_qtyFlushQueued) return; // un envoi attend déjà son tour : il prendra aussi ces clics
      _qtyFlushQueued = true;
      enqueueCartOp(() => { _qtyFlushQueued = false; return flushQty(); }, true)
        .catch((e) => console.warn('[IMCart] changeQty error', e));
    }, QTY_DEBOUNCE_MS);
  }

  // Tourne DANS la file : `cart` = dernier panier reçu → clés de ligne fraîches.
  async function flushQty() {
    if (!_qtyOps.size) { setTotalLoading(false); return; }
    const ops = Array.from(_qtyOps.entries());
    _qtyOps.clear();

    const lines = (cart && Array.isArray(cart.items)) ? cart.items : [];
    const updates = {};
    const sent = [];
    let removing = false;
    ops.forEach(([gid, op]) => {
      const members = lines.filter((x) => gidOf(x) === gid);
      if (!members.length) return; // groupe disparu entre-temps (autre onglet) : le rendu montrera la vérité
      const current = members.reduce((s, x) => s + (x.quantity || 0), 0);
      const target = op.abs !== null ? op.abs : Math.max(0, current + op.delta);
      if (target === current) return;
      // Mise à jour ATOMIQUE de tout le groupe (lignes scindées par la remise) :
      // la 1re clé reçoit la quantité TOTALE voulue, les clés sœurs passent à 0 — le serveur
      // ré-alloue ensuite offert/−35% proprement. /cart/update.js renvoie le panier.
      members.forEach((x, i) => { updates[x.key] = (i === 0 ? target : 0); });
      _qtyInFlight.set(gid, target);
      sent.push(gid);
      if (target <= 0) removing = true;
    });

    let updatedCart = cart; // rien à envoyer (+1 puis −1…) : on ré-affiche le dernier panier reçu
    if (sent.length) {
      updatedCart = null;
      let serverOk = true;
      _suppressHeaderRefresh = true; // évite le getCart redondant du patch global
      try {
        const resp = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates })
        });
        serverOk = resp.ok;
        if (serverOk) {
          try { updatedCart = await resp.json(); } catch (_) { updatedCart = null; }
        }
      } catch (e) {
        serverOk = false;
        console.warn('[IMCart] changeQty error', e);
      } finally {
        _suppressHeaderRefresh = false;
      }
      markCartWrite();

      // Laisse l'animation de sortie se terminer avant le re-render (anti-flash)
      if (removing && serverOk) {
        await new Promise(r => setTimeout(r, 230));
      }
    }

    // Envoi terminé : l'affichage repart de la réponse serveur (+ clics arrivés entre-temps)
    sent.forEach((gid) => _qtyInFlight.delete(gid));
    // render() avec le cart déjà renvoyé par update.js → AUCUN fetch ; échec → relecture /cart.js
    try {
      await render(updatedCart);
    } catch (e) {
      console.warn('[IMCart] render after changeQty error', e);
    }
    if (!_qtyOps.size) setTotalLoading(false);
  }

  /* Audit 27/10 (ACH22) : tiroir vide → jamais « Payer maintenant • 0,00 € » (il menait à
     l'accueil) ; « Voir les maillots » à sa place + un mot si le panier s'est vidé tout seul
     (expiré / commande déjà payée) ou si les cookies sont bloqués (chaque ajout disparaîtrait). */
  const EMPTY_NOTE_EXPIRED = 'Il a expiré, ou ta commande est déjà passée.';
  const EMPTY_NOTE_COOKIES = 'Active les cookies pour que ton panier garde tes maillots.';
  function setExpiredNotice(on) {
    _expiredNotice = !!on;
    if (on) safeSessionSet('imc_cart_expired', '1');
    else safeSessionRemove('imc_cart_expired');
  }
  function syncEmptyState(isEmpty) {
    // Sans le bouton de repli dans le snippet, on ne cache jamais le bouton Payer
    if (els.checkout && els.browse) {
      els.checkout.hidden = !!isEmpty;
      els.browse.hidden = !isEmpty;
    }
    if (els.emptyNote) {
      const note = !isEmpty ? ''
        : (navigator.cookieEnabled === false ? EMPTY_NOTE_COOKIES
          : (_expiredNotice ? EMPTY_NOTE_EXPIRED : ''));
      els.emptyNote.textContent = note;
      els.emptyNote.hidden = !note;
    }
  }

  /* ---------- Discount cookie Shopify : nettoyage fiable ---------- */
  const hasShopifyDiscountApplied = (c) => {
    if (!c) return false;
    if ((c.total_discount || 0) > 0) return true;
    const apps = Array.isArray(c.cart_level_discount_applications) ? c.cart_level_discount_applications : [];
    if (apps.length) return true;
    const codes = Array.isArray(c.discount_codes) ? c.discount_codes : [];
    if (codes.some(x => x && x.applicable)) return true;
    return false;
  };

  // Clear discount cookie en BACKGROUND (sans redirection)
  async function clearShopifyDiscountInBackground() {
    try {
      // Shopify enlève le code si on passe discount vide au checkout
      await fetch('/checkout?discount=', { credentials: 'same-origin' }).catch(() => {});
    } catch(e) {}
  }

  // DÉSACTIVÉ (2026-07-16) : cette routine purgait toute remise « inattendue ». Or
  // (1) la remise automatique « Paliers Grinta » est légitime et déclenchait la purge
  //     à chaque session dès 3 maillots ;
  // (2) un client arrivant via un lien code promo (influenceur) perdait son code en silence.
  // On ne retire plus JAMAIS une remise sans action explicite du client (bouton ✕ du code).
  async function ensureNoUnexpectedShopifyDiscount(c) {
    return c;
  }

  function clearDiscountPersistence() {
    safeLocalRemove('imc_discount_code');
    safeLocalRemove('imc_discount_enabled');
    safeSessionRemove('imc_discount_primed');
  }

  /* ---------- Rendu des propriétés (variante + custom fields) ---------- */
  // Échappe le HTML pour éviter toute injection (XSS) depuis les champs libres
  // (ex: nom/numéro de flocage saisis par le client).
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function renderPropsLine(it) {
    const parts = [];

    // Variante (ex: "S")
    const vt = (it.variant_title || '').trim();
    if (vt) parts.push(`<div class="imc-it__variant">${escapeHtml(vt)}</div>`);

    // Propriétés custom (le flocage Nom/Numéro/Sous le numéro est rendu en DOSSARD visuel, pas en texte)
    const p = it.properties || {};
    const kitKeys = new Set(['nom', 'numero', 'numéro', 'sous le numero', 'sous le numéro']);
    Object.keys(p).forEach((k) => {
      const v = p[k];
      if (v == null || v === '' || v === false) return;
      // Propriété "_" : convention Shopify = masquée au client (checkout/mails).
      // Usage interne (ex: "_veste1_img" pour la vignette du Pack Duo) : jamais affichée ici non plus.
      if (k.charAt(0) === '_') return;
      const keyN = norm(k);
      if (kitKeys.has(keyN) && hasKit(it)) return;
      const label = labelMap.get(keyN) || (k.charAt(0).toUpperCase() + k.slice(1));
      parts.push(`<div class="imc-it__props"><span class="k">${escapeHtml(label)}:</span> <span class="v">${escapeHtml(v)}</span></div>`);
    });

    // Pack Duo sans « Veste 1 » (couleur + taille) : impossible à préparer → on le dit tout de suite
    // (audit ACH3 03/11 ; le garde-fou du thème bloque déjà ces ajouts, ceci rattrape un vieux panier).
    if (it.handle === 'pack-duo-veste-bresil-coupe-vent' && !p['Veste 1']) {
      parts.push('<div class="imc-it__props" style="color:#ffc24b;font-weight:700">⚠️ Ce pack n’a ni couleur ni taille : <a href="/products/bresil-veste-coupe-vent-capuche#im-pd" style="color:inherit;text-decoration:underline">compose ton duo</a> (il remplacera celui-ci)</div>');
    }

    return parts.join('');
  }

  /* ---------- Le Dossard : le flocage du client rendu comme un vrai dos de maillot ---------- */
  function kitProps(it) {
    const p = it.properties || {};
    let nom = '', num = '', sub = '';
    Object.keys(p).forEach((k) => {
      const keyN = norm(k);
      const v = String(p[k] == null ? '' : p[k]).trim();
      if (!v) return;
      if (keyN === 'nom') nom = v;
      else if (keyN === 'numero' || keyN === 'numéro') num = v;
      else if (keyN === 'sous le numero' || keyN === 'sous le numéro') sub = v;
    });
    return { nom, num, sub };
  }
  function hasKit(it) {
    const k = kitProps(it);
    return !!(k.nom || k.num);
  }
  function kitNode(it) {
    // fiche flocage COMPACTE : 3 mini-colonnes (label au-dessus, valeur dessous) —
    // étiqueté = zéro ambiguïté, 2 lignes de haut = zéro encombrement,
    // typographie neutre du site = aucune simulation du rendu réel
    const k = kitProps(it);
    if (!k.nom && !k.num) return null;
    const d = document.createElement('div');
    d.className = 'imc-kit4';
    d.setAttribute('aria-label', 'Flocage : ' + [k.nom, k.num, k.sub].filter(Boolean).join(' '));
    const cell = (lab, val) => {
      const c = document.createElement('span'); c.className = 'imc-kit4__c';
      const l = document.createElement('span'); l.className = 'l'; l.textContent = lab;
      const v = document.createElement('span'); v.className = 'v'; v.textContent = val;
      c.appendChild(l); c.appendChild(v); return c;
    };
    if (k.nom) d.appendChild(cell('Nom', k.nom.toUpperCase()));
    if (k.num) d.appendChild(cell('N°', k.num));
    if (k.sub) d.appendChild(cell('Sous le n°', k.sub.toUpperCase()));
    return d;
  }

  /* ---------- DOM helpers ---------- */
  function show(el, yes) {
    if (!el) return;
    if (yes) {
      el.removeAttribute('hidden');
      el.classList.add('imc-fade--in');
      setTimeout(() => el.classList.remove('imc-fade--in'), 180);
    } else {
      el.setAttribute('hidden', 'hidden');
    }
  }

  /* ---------- Noeud article ---------- */
  function itemNode(it) {
    const t = $('#imc-item', root).content.cloneNode(true);
    const el = t.querySelector('.imc-it');
    el.dataset.key = it.key;

    // Image + titre
    // Pack Duo : 2 vestes dans une seule ligne panier, sans image produit propre —
    // on affiche les 2 couleurs réellement choisies (envoyées en propriétés cachées
    // "_veste1_img"/"_veste2_img" par le snippet im-pack-duo) plutôt qu'une case vide.
    const duoImg1 = it.properties && it.properties['_veste1_img'];
    const duoImg2 = it.properties && it.properties['_veste2_img'];
    const img = t.querySelector('.imc-it__img:not(.imc-it__img--duo)');
    const duo = t.querySelector('[data-imc-duo]');
    if (duoImg1 && duoImg2) {
      img.hidden = true;
      const duoImgs = duo.querySelectorAll('img');
      duoImgs[0].src = duoImg1;
      duoImgs[1].src = duoImg2;
      duoImgs[0].alt = it.properties['Veste 1'] || '';
      duoImgs[1].alt = it.properties['Veste 2'] || '';
      duo.hidden = false;
    } else {
      duo.hidden = true;
      img.hidden = false;
      img.src = it.image || it?.featured_image?.url || '';
      img.alt = it.product_title || '';
    }

    // Variante + propriétés en colonnes
    t.querySelector('[data-imc-props]').innerHTML = renderPropsLine(it);
    const kit = kitNode(it);
    if (kit) t.querySelector('[data-imc-props]').appendChild(kit);

    // PRIX RÉEL SHOPIFY : line_price
    const lineFinal = (typeof it.line_price === 'number')
      ? it.line_price
      : 0;

    let lineOriginal = (typeof it.original_line_price === 'number')
      ? it.original_line_price
      : lineFinal;

    // Pack Duo : la remise est le prix du produit lui-même (pas une remise Shopify),
    // donc original_line_price === line_price aux yeux du panier — sans ça, le client
    // ne voit jamais qu'il économise déjà en achetant le pack. "_compare_total" (posé par
    // im-pack-duo.liquid) porte la vraie valeur des 2 vestes au prix plein.
    const compareTotalPerUnit = it.properties && it.properties['_compare_total']
      ? parseInt(it.properties['_compare_total'], 10) : 0;
    const itQty = it.quantity || 0;
    let packEcoAmount = 0;
    if (compareTotalPerUnit > 0) {
      const bundleOriginalLine = compareTotalPerUnit * itQty;
      if (bundleOriginalLine > lineOriginal) lineOriginal = bundleOriginalLine;
      packEcoAmount = Math.max(0, lineOriginal - lineFinal);
    }

    // Badge "Offert" UNIQUEMENT si TOUTE la ligne (le groupe fusionné) est gratuite.
    // Si seulement une partie des unités du groupe est offerte (ex: 3 maillots
    // fusionnés en 1 ligne, 1 seul réellement à 0€ par la Function), on l'indique
    // avec le compte exact ("1 offert") : jamais "Offert" tout court quand le prix
    // affiché juste à côté n'est pas 0€, ça contredirait le badge.
    const itemQty = it.quantity || 0;
    const zeroUnitQty = it.zeroUnitQty || 0;
    const hasFullGift = (lineFinal === 0) || (zeroUnitQty > 0 && zeroUnitQty >= itemQty);
    const hasPartialGift = !hasFullGift && zeroUnitQty > 0;
    const hasPartialDisc = !hasFullGift && !hasPartialGift &&
      (typeof it.final_line_price === 'number' && typeof it.original_line_price === 'number' &&
       it.original_line_price > 0 && it.final_line_price < it.original_line_price);
    const discPct = hasPartialDisc
      ? Math.round((1 - it.final_line_price / it.original_line_price) * 100)
      : 0;

    t.querySelector('.imc-it__title').innerHTML =
      `${escapeHtml(it.product_title || '')} ` +
      (hasFullGift
        ? `<span class="imc-gift-chip">Offert</span>`
        : hasPartialGift
          ? `<span class="imc-gift-chip">${zeroUnitQty} offert${zeroUnitQty > 1 ? 's' : ''}</span>`
          : (discPct > 0 ? `<span class="imc-gift-chip">−${discPct}%</span>`
            : (packEcoAmount > 0 ? `<span class="imc-gift-chip">−${money(packEcoAmount)}</span>` : '')));

    // Prix affiché (ligne) : toujours le prix RÉEL Shopify (line_price / original_line_price),
    // jamais une simulation locale — un code tapé dans le champ réduction n'est appliqué
    // qu'au moment du checkout, pas à ce panier AJAX, donc ne doit jamais changer ce calcul.
    if (lineOriginal > lineFinal) {
      // Le prix barré passe SOUS le prix final (pas à côté) : sur une carte
      // à 2 chiffres (ex: "99,90 € / 139,80 €"), le mettre en ligne pousse la
      // ligne qty+prix en dehors du tiroir. Empilé, ça tient à toutes les tailles.
      t.querySelector('.imc-it__price').innerHTML =
        `${money(lineFinal)}<span style="display:block;font-size:11px;text-decoration:line-through;opacity:.55;font-weight:500;">${money(lineOriginal)}</span>`;
    } else {
      t.querySelector('.imc-it__price').textContent = money(lineFinal);
    }

    // Contrôles quantité
    // Audit 27/10 (ACH6) : tout passe par le GROUPE (gid) — q = quantité TOTALE des lignes
    // scindées par la remise ; « + » / « − » agissent sur ce total, jamais sur une seule clé.
    const q = it.quantity || 0;
    const gid = it.gid || gidOf(it);
    const input = t.querySelector('.imc-qty__input');
    const incBtn = t.querySelector('.imc-qty--inc');
    const decBtn = t.querySelector('.imc-qty--dec');
    // L'input reflète la vérité la plus récente : intention en attente > envoi en cours > serveur.
    // (Sinon un render pendant une requête réafficherait la valeur serveur périmée.)
    input.value = pendingQty(gid, q);
    // Rendu fait PENDANT une écriture : − / + restent grisés jusqu'à la fin de la requête
    incBtn.addEventListener('click', () => changeQty(gid, { delta: 1 }, el, q));
    decBtn.addEventListener('click', () => changeQty(gid, { delta: -1 }, el, q));
    t.querySelector('.imc-remove').addEventListener('click', () => changeQty(gid, { abs: 0 }, el, q));
    input.addEventListener('change', (e) => {
      const n = parseInt(e.target.value, 10);
      // Saisie vide / non numérique / < 1 → on NE supprime PAS l'article par accident :
      // on restaure la quantité affichée. (Pour retirer : bouton « Retirer » ou « − ».)
      if (!Number.isFinite(n) || n < 1) { e.target.value = pendingQty(gid, q); return; }
      changeQty(gid, { abs: n }, el, q);
    });

    return t;
  }

  /* ---------- Application visuelle des remises ---------- */
  function applyDiscountPreview() {
    estimatedPercentDiscount = 0;

    // Sans code → on masque les lignes récap "Avant / Réduction"
    if (!discountCode) {
      show(els.discLine, false);
      show(els.beforeRow, false);
      show(els.discountRow, false);
      if (els.discHint) els.discHint.hidden = true;
      updateCheckoutLink();
      return;
    }

    // Plus aucune estimation de remise affichée : on n'annonce jamais un prix réduit non garanti.
    // Le code est transmis au paiement, où la remise réelle (si le code existe) s'applique.
    estimatedPercentDiscount = 0;
    if (els.discHint) {
      els.discHint.textContent = `Code enregistré — la remise s’applique au paiement.`;
      els.discHint.hidden = false;
    }

    if (els.discCode) els.discCode.textContent = discountCode;

    // Lignes récap visibles
    if (els.before) els.before.textContent = money(cart.items_subtotal_price);
    show(els.beforeRow, true);
    show(els.discountRow, true);
    show(els.discLine, true);

    updateCheckoutLink();
  }

  /* compteur animé (montants en centimes) — dégradation propre : saute à la valeur finale si reduced-motion.
     Filet : la valeur finale est TOUJOURS posée à dur+80ms, même si les rAF sont gelés (onglet en arrière-plan). */
  function animateAmount(el, from, to, dur, fmt) {
    // jeton anti-réentrance : une nouvelle animation sur le même élément annule
    // l'ancienne (boucle + filet), sinon deux compteurs s'écrivent dessus
    const tok = (el._imcAnimTok = (el._imcAnimTok || 0) + 1);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = fmt(to); return; }
    const t0 = performance.now();
    (function step(now) {
      if (el._imcAnimTok !== tok) return;
      const p = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(from + (to - from) * e));
      if (p < 1) requestAnimationFrame(step);
    })(t0);
    setTimeout(function () { if (el._imcAnimTok === tok) el.textContent = fmt(to); }, dur + 80);
  }

  function updateTotals() {
    // Toujours le total RÉEL Shopify (plus aucune simulation de remise locale).
    const total = (typeof cart.total_price === 'number')
      ? cart.total_price
      : (cart.items_subtotal_price ?? 0);

    if (els.discAmount) {
      // Remise réellement appliquée par la Function (palier maillot, Duo…) UNIQUEMENT —
      // volontairement PAS les promos produit (compare_at des lignes, déjà visibles une par
      // une sur chaque article). Testé ce soir en combinant les deux dans un seul total : le
      // chiffre devient gros et invérifiable au premier coup d'œil, ça fait "trop beau pour
      // être vrai" au lieu de rassurer (retour Ylies 11/09) — décision : cette ligne reste la
      // récompense palier seule, cohérente avec le reste de l'habillage (bandeau Duo, etc.).
      const discField = (typeof cart.total_discount === 'number') ? cart.total_discount : 0;
      const discDelta = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
      const realDisc = Math.max(discField, discDelta);
      const prevDisc = parseInt(els.discAmount.dataset.imcVal || '0', 10);
      if (realDisc > 0 && realDisc !== prevDisc) {
        // le cadeau TOMBE sous les yeux : compte de l'ancienne valeur vers la nouvelle en 0,6 s
        els.discAmount.dataset.imcVal = String(realDisc);
        els.discAmount.classList.add('imc-disc--live');
        animateAmount(els.discAmount, prevDisc, realDisc, 600, (v) => `− ${money(v)}`);
      } else if (realDisc <= 0) {
        els.discAmount.dataset.imcVal = '0';
        els.discAmount.classList.remove('imc-disc--live');
        els.discAmount.textContent = '—';
      }
      // La ligne « Réductions » doit être VISIBLE dès qu'une remise réelle s'applique
      // (les remises de la Function arrivent sans code promo ; applyDiscountPreview,
      // exécutée avant, ne gère que le cas code saisi).
      if (realDisc > 0) show(els.discountRow, true);
      else if (!discountCode) show(els.discountRow, false);
    }

    if (els.total) {
      els.total.textContent = money(total);
      els.total.closest('.imc-row')?.classList.add('imc-fade--in');
      setTimeout(() => els.total.closest('.imc-row')?.classList.remove('imc-fade--in'), 180);
    }

    return total;
  }

  function updateCheckoutButtonLabel(totalCents) {
    if (!els.checkout) return;
    const safeTotal = Number.isFinite(Number(totalCents)) ? Number(totalCents) : 0;
    els.checkout.textContent = `Payer maintenant • ${money(Math.max(0, safeTotal))}`;
  }


  /* ---------- Checkout + Remise persistante ---------- */
  let imcIsNavigating = false;
  let imcWaitingQty = false; // « Payer » attend qu'un + / − soit envoyé (relecture 03/11)
  function updateCheckoutLink() {
    const enc = discountCode ? encodeURIComponent(discountCode) : '';
    const url = discountCode ? `/discount/${enc}?redirect=/checkout` : `/checkout`;
    if (!els.checkout) return;
    els.checkout.setAttribute('href', url);

    // PRÉLOAD de /checkout au survol (souris) ou contact (mobile)
    // Quand l'utilisateur s'apprête à cliquer, on commence déjà à charger la page
    if (!els.checkout.dataset.imPreloadBound) {
      els.checkout.dataset.imPreloadBound = '1';
      const preload = () => {
        const currentUrl = els.checkout.getAttribute('href') || url;
        if (els.checkout.dataset.imPreloadedUrl === currentUrl) return;
        els.checkout.dataset.imPreloadedUrl = currentUrl;
        // Supprime l'ancien prefetch s'il existe
        const old = document.querySelector('link[data-im-checkout-prefetch]');
        if (old) old.remove();
        // Ajoute un nouveau prefetch
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = currentUrl;
        link.setAttribute('data-im-checkout-prefetch', '');
        document.head.appendChild(link);
      };
      els.checkout.addEventListener('pointerenter', preload, { passive: true });
      els.checkout.addEventListener('touchstart', preload, { passive: true });
      els.checkout.addEventListener('focus', preload, { passive: true });
    }

    els.checkout.onclick = (e) => {
      e.preventDefault();

      // Si une nav est déjà en cours mais que l'utilisateur reclique (impatience),
      // on FORCE la navigation à nouveau (peut-être que la 1ère a échoué silencieusement)
      if (imcIsNavigating) {
        // Double appui pendant qu'on envoie encore un + / − : on attend, sinon ça partirait avec l'ancienne quantité
        if (imcWaitingQty) return;
        /* log retiré (prod) */
        try { window.location.href = url; } catch (_) {
          try { window.location.assign(url); } catch (_) {}
        }
        return;
      }

      imcIsNavigating = true;
      /* log retiré (prod) */

      // Loading state : spinner + "Chargement..."
      const originalHtml = els.checkout.innerHTML;
      els.checkout.classList.add('im-loading');
      els.checkout.innerHTML = '<span class="im-loading-spinner" aria-hidden="true"></span><span>Chargement...</span>';

      // Reset rapide (2.5s) : si la nav fonctionne, la page change avant.
      // Si elle échoue, l'utilisateur peut re-cliquer rapidement au lieu d'attendre 8s.
      setTimeout(() => {
        imcIsNavigating = false;
        els.checkout.classList.remove('im-loading');
        els.checkout.innerHTML = originalHtml;
      }, 2500);

      // Lance la navigation
      const go = () => {
        try {
          window.location.assign(url);
        } catch (err) {
          console.error('[IM checkout] location.assign a échoué:', err);
          // Fallback : forcer via href
          try { window.location.href = url; } catch (_) {}
        }
      };
      // Relecture 03/11 : « Payer » touché juste après un + / − → on envoie d'abord la quantité en
      // attente (sinon le paiement partait avec l'ancienne quantité, sans le maillot offert)
      if (_qtyTimer || _qtyOps.size || _qtyFlushQueued || _cartBusy > 0) {
        if (_qtyTimer) { clearTimeout(_qtyTimer); _qtyTimer = null; }
        if (_qtyOps.size && !_qtyFlushQueued) {
          _qtyFlushQueued = true;
          enqueueCartOp(() => { _qtyFlushQueued = false; return flushQty(); }, true).catch(() => {});
        }
        imcWaitingQty = true;
        const goAfter = () => { imcWaitingQty = false; go(); };
        enqueueCartOp(() => {}, false).then(goAfter, goAfter);
      } else {
        go();
      }
    };
  }

  /* Reset le state checkout au retour de la page (back button) */
  window.addEventListener('pageshow', () => {
    imcIsNavigating = false;
    if (els.checkout && els.checkout.classList.contains('im-loading')) {
      els.checkout.classList.remove('im-loading');
      updateCheckoutLink();
    }
  });

  /* Si la nav démarre vraiment (beforeunload fired), on est sûr que ça marche */
  window.addEventListener('beforeunload', () => {
    // La nav démarre — on peut clear le timeout (Page va changer de toute façon)
    // Pas de cleanup nécessaire ici, juste un marqueur visuel pour le user qui voit "Chargement..."
  });

  function primeDiscountCookie() {
    if (!discountCode) return;

    if (safeSessionGet('imc_discount_primed') === discountCode) return;
    safeSessionSet('imc_discount_primed', discountCode);

    fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=/`, { credentials: 'same-origin' })
      .catch(() => {});
  }

  async function saveCartNote(force = false) {
    if (!els.noteInput) return;
    const note = els.noteInput.value || '';
    if (!force && note === lastSavedNote) return;

    try {
      // Audit 27/10 (ACH6) : la note passe aussi par la file unique (jamais en parallèle d'une quantité)
      await enqueueCartOp(() => fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note })
      }), false);
      lastSavedNote = note;
      if (els.noteStatus) {
        els.noteStatus.textContent = 'Enregistré';
        els.noteStatus.hidden = false;
        setTimeout(() => {
          if (els.noteStatus) els.noteStatus.hidden = true;
        }, 1200);
      }
    } catch (e) {
      if (els.noteStatus) {
        els.noteStatus.textContent = 'Erreur';
        els.noteStatus.hidden = false;
      }
    }
  }

  function queueCartNoteSave() {
    if (!els.noteInput) return;
    if (noteSaveTimer) clearTimeout(noteSaveTimer);
    noteSaveTimer = setTimeout(() => {
      saveCartNote(false);
    }, 450);
  }

  function playShippingStepAnimation(step) {
    if (!els.shipWrap) return;
    const midClass = 'imc-shipprog--pulse-mid';
    const finalClass = 'imc-shipprog--celebrate';
    const targetClass = step === 2 ? finalClass : midClass;
    const duration = step === 2 ? 1050 : 900;

    els.shipWrap.classList.remove(midClass, finalClass);
    void els.shipWrap.offsetWidth;
    els.shipWrap.classList.add(targetClass);

    if (shippingAnimTimer) clearTimeout(shippingAnimTimer);
    shippingAnimTimer = setTimeout(() => {
      els.shipWrap.classList.remove(midClass, finalClass);
    }, duration);

    if (step === 2) {
      playShippingEmojiBurst();
    }
  }

  function playShippingEmojiBurst() {
    if (!els.shipWrap) return;

    const oldLayer = els.shipWrap.querySelector('.imc-shipprog__burst');
    if (oldLayer) oldLayer.remove();

    const layer = document.createElement('div');
    layer.className = 'imc-shipprog__burst';

    const icons = ['🎁', '⚽', '✨', '🚚', '✨', '⚽'];
    const dropsCount = 10;

    for (let i = 0; i < dropsCount; i += 1) {
      const drop = document.createElement('span');
      const icon = icons[Math.floor(Math.random() * icons.length)];
      const x = 8 + Math.random() * 84;
      const delay = Math.round(Math.random() * 380);
      const dur = 1400 + Math.round(Math.random() * 500);
      const drift = -18 + Math.round(Math.random() * 36);
      const rot = -35 + Math.round(Math.random() * 70);
      const size = 12 + Math.round(Math.random() * 6);

      drop.className = 'imc-shipprog__drop';
      drop.textContent = icon;
      drop.style.setProperty('--x', `${x}%`);
      drop.style.setProperty('--delay', `${delay}ms`);
      drop.style.setProperty('--dur', `${dur}ms`);
      drop.style.setProperty('--drift', `${drift}px`);
      drop.style.setProperty('--rot', `${rot}deg`);
      drop.style.setProperty('--size', `${size}px`);
      layer.appendChild(drop);
    }

    els.shipWrap.appendChild(layer);
    if (shipBurstTimer) clearTimeout(shipBurstTimer);
    shipBurstTimer = setTimeout(() => {
      layer.remove();
    }, 2700);
  }

  function renderShippingProgress() {
    if (!els.shipWrap) return;

    const count = Number(cart.item_count || 0);
    const threshold = FREE_SHIP_THRESHOLD;
    const clamped = Math.max(0, Math.min(count, threshold));
    const pct = Math.round((clamped / threshold) * 100);
    const remaining = Math.max(0, threshold - count);

    if (els.shipCount) {
      els.shipCount.textContent = `${clamped}/${threshold}`;
    }

    if (els.shipBar) {
      els.shipBar.style.width = `${pct}%`;
    }

    els.shipWrap.style.setProperty('--imc-ship-progress', `${pct}%`);

    // La livraison N'EST PAS offerte (port réel configuré en Admin) : messages alignés
    // sur l'offre réelle (3e offert à 2 maillots) et frais toujours « Calculée au paiement ».
    if (els.shipMsg) {
      if (remaining > 1) {
        els.shipMsg.textContent = `Plus que ${remaining} maillots pour débloquer le 3e offert.`;
      } else if (remaining === 1) {
        els.shipMsg.textContent = 'Plus qu\'1 maillot pour débloquer le 3e offert.';
      } else {
        els.shipMsg.textContent = '3e maillot offert débloqué.';
      }
    }

    if (els.shippingValue) {
      els.shippingValue.classList.remove('imc-row__value--ok', 'imc-row__value--hint');
      els.shippingValue.textContent = 'Calculée au paiement';
      els.shippingValue.classList.add('imc-row__value--hint');
    }

    const step = remaining === 0 ? 2 : count > 0 ? 1 : 0;
    const isMidStep = step === 1 && clamped === 1;

    els.shipWrap.classList.toggle('is-half', isMidStep);
    els.shipWrap.classList.toggle('is-unlocked', step === 2);

    if (lastShippingStep >= 0 && step !== lastShippingStep && step > 0) {
      playShippingStepAnimation(step);
    }
    lastShippingStep = step;
  }

  /* ---------- Grille "découvre aussi / complète ta commande" ----------
     Statique côté Liquid (Grinta Édition, 8 produits max) : on ne fait ici que
     (1) changer le titre selon vide/rempli, (2) masquer les produits déjà dans
     le panier pour ne jamais re-suggérer ce que le client a déjà, (3) cacher
     toute la section si plus aucun produit n'est pertinent à montrer. */
  const elsXsell = document.getElementById('im-cart')?.querySelector('[data-imc-xsell]');
  // Audit 27/10 (ACH23) : prix des suggestions réécrits au format français, comme les lignes
  // (le Liquid suit le format de devise de la boutique : « €30,90 » tant que l'admin n'est pas corrigé).
  elsXsell?.querySelectorAll('[data-imc-cents]').forEach((s) => {
    const c = parseInt(s.getAttribute('data-imc-cents'), 10);
    if (Number.isFinite(c)) s.textContent = money(c);
  });
  function updateXsell(cartData) {
    if (!elsXsell) return;
    const title = elsXsell.querySelector('[data-imc-xsell-title]');
    const isEmpty = !cartData.items || !cartData.items.length;
    if (title) title.textContent = isEmpty ? 'Découvre aussi' : 'Complète ta commande';
    const inCartHandles = new Set((cartData.items || []).map(function (it) { return it.handle; }));
    let visibleCount = 0;
    elsXsell.querySelectorAll('[data-imc-xsell-add]').forEach(function (btn) {
      const already = inCartHandles.has(btn.getAttribute('data-imc-xsell-handle'));
      btn.hidden = already;
      if (!already) visibleCount++;
    });
    elsXsell.hidden = visibleCount === 0;
  }

  /* ---------- Rendu global ---------- */
  // render(preloadedCart) : si un cart est fourni (ex: réponse de /cart/change.js),
  // on l'utilise directement → évite un fetch /cart.js redondant.
  let _cartRetry = 0;
  async function render(preloadedCart) {
    let fetched;
    // Audit 27/10 (ACH6) : une lecture /cart.js partie AVANT une de nos écritures et revenue
    // APRÈS est périmée (anciennes clés, anciennes quantités) : on l'ignore, l'écriture a déjà
    // rendu un panier plus récent.
    const fromServer = !(preloadedCart && Array.isArray(preloadedCart.items));
    const writeSeqAtStart = _cartWriteSeq;
    try {
      fetched = fromServer
        ? await getCart()
        : preloadedCart;
      fetched = await ensureNoUnexpectedShopifyDiscount(fetched);
    } catch (e) {
      /* Échec réseau /cart.js : on NE vide PAS la liste et on n'affiche pas
         un faux "panier vide" (perçu comme "articles cachés"). On retente ;
         l'affichage courant reste intact jusqu'à des données fiables. */
      if (_cartRetry < 3) {
        _cartRetry++;
        setTimeout(function () { render(preloadedCart).catch(function () {}); }, 800);
      }
      return;
    }
    if (fromServer && writeSeqAtStart !== _cartWriteSeq) return;
    _cartRetry = 0;
    cart = fetched;

    // Audit 27/10 (ACH22) : panier passé à 0 SANS aucune écriture depuis le dernier rendu
    // (ni ici, ni dans un autre onglet qui aurait remis le compteur à 0) = vidé tout seul.
    const nowCount = toSafeCount(cart.item_count);
    const prevCount = toSafeCount(safeLocalGet('imc_last_count'));
    if (nowCount > 0) setExpiredNotice(false);
    else if (prevCount > 0 && !_cartWriteSeen) setExpiredNotice(true);
    _cartWriteSeen = false;
    safeLocalSet('imc_last_count', String(nowCount));

    // Reset sécurité
    estimatedPercentDiscount = 0;

    if (els.items) els.items.innerHTML = '';
    if (els.count) els.count.textContent = cart.item_count || 0;
    syncHeaderCounts(cart.item_count || 0);
    // Palier "3e offert" etc. — reflète EXACTEMENT la règle de la Shopify Function :
    //   • Pack Duo (bundle a prix fixe) : jamais compté, il a déjà sa propre remise.
    //   • Veste achetée seule : compte comme une unité normale s'il y en a UNE SEULE
    //     dans le panier ; dès qu'il y en a 2 ou plus (equivalent pack, ou deux vestes
    //     séparées), elles ont DEJA leur propre avantage → exclues en bloc pour ne pas
    //     cumuler un 2e avantage sur les maillots par-dessus ("ça repart à zéro").
    // Si ce calcul divergeait du vrai calcul serveur, la bannière promettrait un cadeau
    // qui ne se déclenche pas — les deux DOIVENT rester en miroir l'un de l'autre.
    const packDuoLines = (cart.items || []).filter(function (it) { return it.handle === 'pack-duo-veste-bresil-coupe-vent'; });
    const packDuoLine = packDuoLines[0];
    const soloVesteLines = (cart.items || []).filter(function (it) { return it.product_type === 'Veste' && it.handle !== 'pack-duo-veste-bresil-coupe-vent'; });
    const soloVesteQty = soloVesteLines.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
    const soloVesteCountsTowardTier = soloVesteQty === 1;
    const otherQty = (cart.items || []).reduce(function (sum, it) {
      const isPackDuo = it.handle === 'pack-duo-veste-bresil-coupe-vent';
      const isSoloVeste = it.product_type === 'Veste' && !isPackDuo;
      return (isPackDuo || isSoloVeste) ? sum : sum + (it.quantity || 0);
    }, 0);
    const tierCount = otherQty + (soloVesteCountsTowardTier ? soloVesteQty : 0);
    root.setAttribute('data-imc-tier-count', tierCount);
    checkVarMoment(tierCount);

    // Bandeau "Pack Duo" : ne remplace le stepper maillot que si le panier ne contient
    // QUE des vestes (rien d'autre à faire progresser) — dès qu'un maillot (ou tout
    // autre article) est présent, le stepper maillot reste affiché et reflète le vrai
    // calcul ci-dessus (fini le cas où il disparaissait dès qu'une veste était ajoutée).
    const soloVeste = soloVesteLines[0];
    root.setAttribute('data-imc-has-duo', (packDuoLine && otherQty === 0) ? '1' : '0');
    root.setAttribute('data-imc-has-veste', (soloVeste && otherQty === 0 && soloVesteQty === 1) ? '1' : '0');
    if (soloVeste && soloVeste.url) root.setAttribute('data-imc-veste-url', soloVeste.url);
    // Photo du bandeau : depuis la veste solo si présente, sinon depuis la photo de la
    // 1ère veste du Pack Duo lui-même (propriété cachée posée par im-pack-duo.liquid) —
    // sans ce repli, ajouter le Pack Duo directement (sans veste solo au préalable dans
    // la session) laisse le rond du bandeau sans image.
    const soloVesteImg = soloVeste && (soloVeste.image || (soloVeste.featured_image && soloVeste.featured_image.url));
    const packDuoOwnImg = packDuoLine && packDuoLine.properties && packDuoLine.properties['_veste1_img'];
    const vesteImg = soloVesteImg || packDuoOwnImg;
    if (vesteImg) root.setAttribute('data-imc-veste-img', vesteImg);
    // Économie RÉELLE du bandeau "Offre Duo activée" : somme sur TOUTES les lignes
    // Pack Duo (quantité >1, ou plusieurs coloris = plusieurs lignes), jamais le prix
    // figé d'un seul pack — sinon "2 vestes" et le montant affiché mentent dès qu'il y
    // a plus d'un pack dans le panier.
    const packDuoQty = packDuoLines.reduce(function (sum, it) { return sum + (it.quantity || 0); }, 0);
    const packDuoEcoTotal = packDuoLines.reduce(function (sum, it) {
      const compareTotalPerUnit = it.properties && it.properties['_compare_total']
        ? parseInt(it.properties['_compare_total'], 10) : 0;
      const perUnitEco = compareTotalPerUnit > 0 ? Math.max(0, compareTotalPerUnit - (it.price || 0)) : 0;
      return sum + perUnitEco * (it.quantity || 0);
    }, 0);
    root.setAttribute('data-imc-duo-qty', packDuoQty || 0);
    root.setAttribute('data-imc-duo-eco-total', packDuoEcoTotal || 0);
    updateXsell(cart);
    if (els.noteInput && document.activeElement !== els.noteInput) {
      const nextNote = cart.note || '';
      els.noteInput.value = nextNote;
      lastSavedNote = nextNote;
    }

    if (!cart.items.length) {
      if (els.empty) els.empty.hidden = false;
      // Audit 27/10 (ACH22) : « Voir les maillots » remplace « Payer maintenant • 0,00 € »
      syncEmptyState(true);
      // Toujours garder le panneau réduction fermé quand le panier est vide
      setDiscountPanelOpen(false, false);
      show(els.shippingRow, false);
      show(els.beforeRow, false);
      show(els.discountRow, false);
      show(els.discLine, false);
      if (els.total) els.total.textContent = money(0);
      updateCheckoutButtonLabel(0);
      renderShippingProgress();
      document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: 0 } }));
      return;
    }

    if (els.empty) els.empty.hidden = true;
    // Audit 27/10 (ACH22) : panier rempli → le vrai bouton Payer revient
    syncEmptyState(false);
    show(els.shippingRow, true);

    // UNE ligne par variante+perso : les scissions de la remise (offert/−35%)
    // sont fusionnées ; le prix barré montre l'économie du groupe.
    groupCartItems(cart.items).forEach(it => {
      els.items.appendChild(itemNode(it));
    });

    applyDiscountPreview();
    const total = updateTotals();
    updateCheckoutButtonLabel(total);
    renderShippingProgress();

    document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: cart.item_count } }));
  }

  function setDiscountPanelOpen(open, focusInput = false) {
    if (!els.discPanel) return;

    if (open) {
      els.discPanel.removeAttribute('hidden');
      els.discPanel.classList.add('imc-disc--open');
      els.discTog?.setAttribute('aria-expanded', 'true');
      els.discTog?.querySelector('.imc-disc__icon')?.replaceChildren('−');

      if (focusInput) {
        requestAnimationFrame(() => {
          els.discInput?.focus({ preventScroll: true });
        });
      }
      return;
    }

    els.discPanel.classList.remove('imc-disc--open');
    els.discPanel.setAttribute('hidden', 'hidden');
    els.discTog?.setAttribute('aria-expanded', 'false');
    els.discTog?.querySelector('.imc-disc__icon')?.replaceChildren('+');
  }

  root.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-imc-disc-tog]');
    if (!tog || !root.contains(tog)) return;
    const shouldOpen = els.discPanel?.hasAttribute('hidden');
    setDiscountPanelOpen(!!shouldOpen, !!shouldOpen);
  });

  /* ---------- Ajout rapide depuis la grille "découvre aussi" ----------
     Le "+" n'ajoute plus directement : il ouvre une fenêtre pour choisir le
     coloris (si le produit en a un), la taille, et le flocage Nom/Numéro/Sous
     le numéro (seulement si data-imc-xsell-flocage="1", jamais sur une veste —
     mêmes noms de propriétés que la fiche produit pour rester cohérent partout
     ailleurs). Les variantes complètes (product.variants | json) sont portées
     par la tuile : on résout la bonne variante au fil des choix de l'acheteur,
     comme sur une vraie fiche produit, plutôt que de figer un variant par défaut. */
  const quick = root.querySelector('[data-imc-quick]');
  const quickImg = root.querySelector('[data-imc-quick-img]');
  const quickTitle = root.querySelector('[data-imc-quick-title]');
  const quickPrice = root.querySelector('[data-imc-quick-price]');
  const quickCompare = root.querySelector('[data-imc-quick-compare]');
  const quickColorRow = root.querySelector('[data-imc-quick-color-row]');
  const quickColors = root.querySelector('[data-imc-quick-colors]');
  const quickSizeRow = root.querySelector('[data-imc-quick-size-row]');
  const quickSizes = root.querySelector('[data-imc-quick-sizes]');
  const quickFloc = root.querySelector('[data-imc-quick-floc]');
  const quickNom = root.querySelector('[data-imc-quick-nom]');
  const quickNum = root.querySelector('[data-imc-quick-num]');
  const quickSub = root.querySelector('[data-imc-quick-sub]');
  const quickCta = root.querySelector('[data-imc-quick-cta]');
  let quickVariantId = null;
  let quickCtaBusy = false;
  let quickState = null; // {variants, colorIdx, sizeIdx, fallbackImg, color, size}

  function optAt(variant, idx) {
    if (idx === 0) return variant.option1;
    if (idx === 1) return variant.option2;
    if (idx === 2) return variant.option3;
    return null;
  }

  function resolveVariant() {
    const st = quickState;
    if (!st) return null;
    return st.variants.find(function (v) {
      if (st.colorIdx > -1 && optAt(v, st.colorIdx) !== st.color) return false;
      if (st.sizeIdx > -1 && optAt(v, st.sizeIdx) !== st.size) return false;
      return true;
    }) || null;
  }

  function updateQuickPricing() {
    const v = resolveVariant();
    const price = v ? v.price : 0;
    const compare = v ? v.compare_at_price : 0;
    if (quickPrice) quickPrice.textContent = money(price || 0);
    if (quickCompare) {
      if (compare && price && compare > price) { quickCompare.textContent = money(compare); quickCompare.hidden = false; }
      else quickCompare.hidden = true;
    }
    if (quickImg) {
      const img = (v && v.featured_image && v.featured_image.src) || quickState.fallbackImg;
      if (img) quickImg.src = img;
    }
    quickVariantId = v ? v.id : null;
    if (quickCta) quickCta.disabled = !v || !v.available;
  }

  function renderSizesForColor() {
    const st = quickState;
    if (!quickSizes) return;
    quickSizes.innerHTML = '';
    if (st.sizeIdx === -1) { if (quickSizeRow) quickSizeRow.hidden = true; return; }
    // Tailles distinctes (dans l'ordre du catalogue), disponibles pour le coloris choisi.
    const seen = {};
    const sizes = [];
    st.variants.forEach(function (v) {
      if (st.colorIdx > -1 && optAt(v, st.colorIdx) !== st.color) return;
      const label = optAt(v, st.sizeIdx);
      if (label == null || seen[label]) return;
      seen[label] = true;
      sizes.push({ label: label, available: v.available });
    });
    if (sizes.length <= 1 && sizes[0] && sizes[0].available) { if (quickSizeRow) quickSizeRow.hidden = true; st.size = sizes[0].label; return; }
    if (quickSizeRow) quickSizeRow.hidden = sizes.length === 0;
    if (!sizes.some(function (s) { return s.label === st.size; })) {
      const firstAvailable = sizes.find(function (s) { return s.available; }) || sizes[0];
      st.size = firstAvailable ? firstAvailable.label : null;
    }
    sizes.forEach(function (s) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'imc-quick__size';
      b.textContent = s.label;
      b.setAttribute('role', 'radio');
      b.disabled = !s.available;
      const active = s.label === st.size;
      b.setAttribute('aria-checked', active ? 'true' : 'false');
      if (active) b.classList.add('is-active');
      b.addEventListener('click', function () {
        st.size = s.label;
        quickSizes.querySelectorAll('.imc-quick__size').forEach(function (o) {
          o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        updateQuickPricing();
      });
      quickSizes.appendChild(b);
    });
  }

  function renderColors() {
    const st = quickState;
    if (!quickColors) return;
    quickColors.innerHTML = '';
    if (st.colorIdx === -1) { if (quickColorRow) quickColorRow.hidden = true; return; }
    const seen = {};
    const colors = [];
    st.variants.forEach(function (v) {
      const label = optAt(v, st.colorIdx);
      if (label == null || seen[label]) return;
      seen[label] = true;
      const img = (v.featured_image && v.featured_image.src) || st.fallbackImg;
      const hasAvailable = st.variants.some(function (v2) { return optAt(v2, st.colorIdx) === label && v2.available; });
      colors.push({ label: label, img: img, available: hasAvailable });
    });
    if (colors.length <= 1) { if (quickColorRow) quickColorRow.hidden = true; if (colors[0]) st.color = colors[0].label; return; }
    if (quickColorRow) quickColorRow.hidden = false;
    if (!colors.some(function (c) { return c.label === st.color; })) {
      const firstAvailable = colors.find(function (c) { return c.available; }) || colors[0];
      st.color = firstAvailable.label;
    }
    colors.forEach(function (c) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'imc-quick__color';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.label);
      const active = c.label === st.color;
      b.setAttribute('aria-checked', active ? 'true' : 'false');
      if (active) b.classList.add('is-active');
      b.innerHTML = '<span class="imc-quick__color-img"><img src="' + c.img + '" alt="" loading="lazy"></span><span class="imc-quick__color-check" aria-hidden="true">✓</span>';
      b.addEventListener('click', function () {
        st.color = c.label;
        quickColors.querySelectorAll('.imc-quick__color').forEach(function (o) {
          o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        renderSizesForColor();
        updateQuickPricing();
      });
      quickColors.appendChild(b);
    });
  }

  function openQuick(btn) {
    if (!quick) return;
    if (quickTitle) quickTitle.textContent = btn.getAttribute('data-imc-xsell-title') || '';
    let variants = [];
    try { variants = JSON.parse(btn.getAttribute('data-imc-xsell-variants') || '[]'); } catch (e) {}
    const optionNames = (btn.getAttribute('data-imc-xsell-option-names') || '').split('|').filter(Boolean);
    const colorIdx = optionNames.findIndex(function (n) { return /coul/i.test(n); });
    const sizeIdx = optionNames.findIndex(function (n) { return /taille/i.test(n); });
    quickState = {
      variants: variants,
      colorIdx: colorIdx,
      sizeIdx: sizeIdx,
      fallbackImg: btn.getAttribute('data-imc-xsell-img') || '',
      color: null,
      size: null
    };

    renderColors();
    renderSizesForColor();
    updateQuickPricing();

    const hasFlocage = btn.getAttribute('data-imc-xsell-flocage') === '1';
    if (quickFloc) quickFloc.hidden = !hasFlocage;
    if (quickNom) quickNom.value = '';
    if (quickNum) quickNum.value = '';
    if (quickSub) quickSub.value = '';

    quick.hidden = false;
    requestAnimationFrame(function () { quick.classList.add('is-open'); });
  }

  function closeQuick() {
    if (!quick) return;
    quick.classList.remove('is-open');
    setTimeout(function () { quick.hidden = true; }, 200);
  }

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-imc-xsell-add]');
    if (btn && root.contains(btn)) { openQuick(btn); return; }
    if (e.target.closest('[data-imc-quick-close]')) closeQuick();
  });

  quickCta?.addEventListener('click', async () => {
    if (quickCtaBusy || !quickVariantId) return;
    quickCtaBusy = true;
    const prevTxt = quickCta.textContent;
    quickCta.textContent = 'Ajout…';
    quickCta.disabled = true;
    const properties = {};
    // Prix barré universel : le panier Shopify ne renvoie jamais le compare_at_price
    // d'une ligne — sans ça, l'économie de ce produit disparaît une fois dans le
    // panier. On la transporte en propriété masquée, lue par itemNode() pour
    // n'importe quelle ligne (déjà utilisé pour le Pack Duo, généralisé ici).
    const addedVariant = resolveVariant();
    if (addedVariant && addedVariant.compare_at_price > addedVariant.price) {
      properties['_compare_total'] = String(addedVariant.compare_at_price);
    }
    // Jamais de properties[Nom]="" — un champ flocage vide ne doit pas polluer la ligne panier.
    if (quickFloc && !quickFloc.hidden) {
      const nom = (quickNom?.value || '').trim();
      const num = (quickNum?.value || '').trim();
      const sub = (quickSub?.value || '').trim();
      if (nom) properties['Nom'] = nom;
      if (num) properties['Numéro'] = num;
      if (sub) properties['Sous le numéro'] = sub;
    }
    const addBody = JSON.stringify({ id: quickVariantId, quantity: 1, properties });
    try {
      // Audit 27/10 (ACH6) : l'ajout rapide attend son tour dans la file unique (jamais en
      // parallèle d'un « + » / « − »), puis relit le panier pour avoir les nouvelles clés.
      await enqueueCartOp(async () => {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: addBody
        }).finally(markCartWrite);
        if (res.ok) {
          await render();
          closeQuick();
        }
      }, true);
    } catch (err) {}
    quickCta.textContent = prevTxt;
    quickCta.disabled = false;
    quickCtaBusy = false;
  });

  /* ---------- Appliquer / Effacer code ---------- */
  els.discApply?.addEventListener('click', () => {
    discountCode = (els.discInput.value || '').trim().toUpperCase();
    // Aucune persistance locale: code actif seulement pour cette page.
    clearDiscountPersistence();

    // reset anti-boucle autoclear
    safeSessionRemove('imc_autoclear_discount');

    primeDiscountCookie();
    updateCheckoutLink();

    setTotalLoading(true);
    render().finally(() => setTotalLoading(false));
  });

  els.discClear?.addEventListener('click', () => {
    discountCode = '';
    clearDiscountPersistence();
    if (els.discInput) els.discInput.value = '';

    safeSessionRemove('imc_discount_primed');
    safeSessionRemove('imc_autoclear_discount');

    setTotalLoading(true);
    clearShopifyDiscountInBackground()
      .finally(() => {
        updateCheckoutLink();
        render().finally(() => setTotalLoading(false));
      });
  });

  els.discInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); els.discApply?.click(); }
  });

  els.noteInput?.addEventListener('input', () => {
    queueCartNoteSave();
  });
  els.noteInput?.addEventListener('blur', () => {
    saveCartNote(true);
  });

  /* ---------- Drawer open/close ---------- */
  let imcCloseTimer = null;
  let imcPrevOverflow = '';
  const legacyDrawerClasses = [
    'js-drawer-open',
    'js-drawer-open-left',
    'js-drawer-open-right',
    'drawer-open',
    'cart-open',
    'overflow-hidden'
  ];

  function clearLegacyDrawerLocks() {
    document.body.classList.remove(...legacyDrawerClasses, 'imc-open');
    document.documentElement.classList.remove(...legacyDrawerClasses);
    document.body.style.overflow = '';

    if (window.jQuery) {
      try {
        window.jQuery('.page-element').off('.drawer');
        window.jQuery('body, html').off('.drawer');
        window.jQuery(document).off('focusin.drawer_focus');
      } catch (_) {}
    }
  }

  function lockImCartScroll() {
    imcPrevOverflow = document.documentElement.style.overflow || '';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('imc-open');
  }

  function unlockImCartScroll() {
    document.documentElement.style.overflow = imcPrevOverflow || '';
    document.body.classList.remove('imc-open');
    clearLegacyDrawerLocks();
  }

  function resetCartUiState() {
    root.classList.remove('imc--open', 'imc--closing');
    root.setAttribute('aria-hidden', 'true');
    if (imcCloseTimer) {
      clearTimeout(imcCloseTimer);
      imcCloseTimer = null;
    }
    unlockImCartScroll();
  }

  function open() {
    if (imcCloseTimer) { clearTimeout(imcCloseTimer); imcCloseTimer = null; }

    clearLegacyDrawerLocks();
    // Ouverture propre: ne jamais auto-déplier "Réduction"
    setDiscountPanelOpen(false, false);
    root.classList.remove('imc--closing');
    root.classList.add('imc--open');
    root.setAttribute('aria-hidden', 'false');

    lockImCartScroll();
  }

  function close() {
    if (!root.classList.contains('imc--open')) {
      unlockImCartScroll();
      return;
    }

    // Audit 27/10 (ACH22) : le mot « panier expiré » a été vu → on ne le remontre plus
    if (_expiredNotice && els.emptyNote && !els.emptyNote.hidden) {
      setExpiredNotice(false);
      els.emptyNote.textContent = '';
      els.emptyNote.hidden = true;
    }

    root.classList.add('imc--closing');
    root.classList.remove('imc--open');

    unlockImCartScroll();

    if (imcCloseTimer) clearTimeout(imcCloseTimer);
    imcCloseTimer = setTimeout(() => {
      root.classList.remove('imc--closing');
      root.setAttribute('aria-hidden', 'true');
    }, 320);
  }

  root.addEventListener('click', (e) => {
    if (e.target.matches('[data-imc-close], .imc__backdrop')) close();
  });

  // Ferme TOUJOURS le tiroir avant de suivre un lien interne (paliers maillot, "Choisir"
  // du cadeau, offre Pack Duo…) : si ce lien pointe vers LA MÊME URL que la page actuelle
  // (cas réel : panier ouvert depuis une fiche produit dont l'ancre #im-pd renvoie sur cette
  // même page+variante), le navigateur ne fait qu'un scroll interne SANS recharger — rien ne
  // referme alors le tiroir tout seul, et son fond assombri plein écran bloque tous les clics
  // en dessous (bug confirmé en direct, sombre sur sombre donc quasi invisible à l'écran).
  // Exclu : [data-imc-checkout], qui gère lui-même sa propre transition (spinner "Chargement…"
  // affiché PENDANT que le tiroir reste ouvert) — le fermer ici casserait ce feedback.
  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (a && root.contains(a) && !a.matches('[data-imc-checkout]')) close();
  });

  function openAndRender() {
    if (!root.classList.contains('imc--open')) {
      open();
    }
    setTotalLoading(true);
    // Audit 27/10 (ACH6) : relecture par la file → un « + » tapé dès l'ouverture attend le panier frais
    return refreshCart().finally(() => setTotalLoading(false));
  }

  /* ---------- Init ---------- */
  installHeaderCountAutoRefresh();
  clearDiscountPersistence();
  if (els.discInput) els.discInput.value = '';
  // Par défaut on laisse l'accordéon réduction fermé, même avec un code mémorisé
  setDiscountPanelOpen(false, false);
  updateCheckoutLink();
  setTotalLoading(true);
  refreshCart().finally(() => setTotalLoading(false));

  // API + triggers externes
  window.IMCart = { open: openAndRender, close, render };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-im-open-cart]');
    if (!t) return;
    e.preventDefault();
    openAndRender();
  });
  document.addEventListener('im:cart:updated', (e) => {
    if (typeof e?.detail?.count === 'number') {
      syncHeaderCounts(e.detail.count);
      return;
    }
    queueHeaderCountRefresh(40);
  });
  ['cart:updated', 'cart:item-added', 'added_to_cart', 'added.ajaxProduct', 'cart:add', 'product:added']
    .forEach((evt) => {
      document.addEventListener(evt, () => queueHeaderCountRefresh(70), true);
    });
  window.addEventListener('pageshow', (e) => {
    resetCartUiState();
    // Audit 27/10 (ACH7) : page restaurée par le bouton retour (cache bfcache) → le tiroir ET la
    // barre des paliers (qui lit data-imc-tier-count posé par render) repartent d'un /cart.js frais.
    // Avant : seul le chiffre de l'icône bougeait (« Encore 2 maillots » alors qu'il en manquait 1).
    if (e && e.persisted) {
      // Relecture 03/11 : la fenêtre « choisis ta taille » ouverte avant de partir ne reste pas affichée
      try { closeQuick(); } catch (_) {}
      refreshCart();
    }
    else queueHeaderCountRefresh(0);
  });
  window.addEventListener('pagehide', resetCartUiState);
  document.addEventListener('visibilitychange', () => {
    // Audit 27/10 (ACH7) : retour sur l'onglet (autre onglet, autre appli) → tout le panier relu
    // (1 requête, par la file), plus seulement le compteur.
    if (!document.hidden) refreshCart();
  });
  document.addEventListener('keydown', (e) => { if (e.key !== 'Escape') return; if (window.theme && theme.NavDrawer && theme.NavDrawer.drawerIsOpen) { theme.NavDrawer.close(); return; } close(); });
})();

/* Panier → cacher la bulle à l'ouverture, la remettre à la fermeture */
(() => {
  const cart = document.getElementById('im-cart') || document.querySelector('.imc');
  if (!cart) return;

  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];
  const FALLBACK_CANDIDATES = [
    'iframe[src*="chat"]',
    'iframe[id*="chat"]',
    '[id*="chat"]',
    '[class*="chat"]',
    '[id*="launcher"]',
    '[class*="launcher"]'
  ].join(',');

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));
    document.querySelectorAll(FALLBACK_CANDIDATES).forEach(el => {
      if (!(el instanceof HTMLElement) || cart.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });
    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(cart);
    return cart.classList.contains('imc--open') ||
           cart.classList.contains('is-open') ||
           cart.getAttribute('aria-hidden') === 'false' ||
           cs.display === 'block';
  };

  const sync = () => (isOpen() ? hide() : show());
  let syncTimer = null;
  const scheduleSync = (delay = 80) => {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay);
  };

  new MutationObserver(() => scheduleSync(0))
    .observe(cart, { attributes:true, attributeFilter:['class','style','aria-hidden'] });
  new MutationObserver(() => scheduleSync(120)).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-im-open-cart], .js-open-cart, [href="#cart-drawer"]')) {
      scheduleSync(0);
    }
    if (e.target.closest('[data-imc-close], .imc__backdrop')) {
      scheduleSync(0);
    }
  }, true);

  sync();
})();
